export default "__VITE_ASSET__1101d319__"